
import { createApiClient } from 'Network/ApiClient';

export const ActivityPayerRulesAxiosInstance = createApiClient('user/');


